// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";

var boundingBox = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.display("flex"),
      BsCssJs$PrezzeeRibbon.justifySelf("flexStart"),
      BsCssJs$PrezzeeRibbon.justifyContent("center"),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.CategoryTiles.tablet, [BsCssJs$PrezzeeRibbon.flexDirection("column")]),
      BsCssJs$PrezzeeRibbon.children([
            BsCssJs$PrezzeeRibbon.maxWidth(BsCssJs$PrezzeeRibbon.px(285)),
            BsCssJs$PrezzeeRibbon.maxHeight(BsCssJs$PrezzeeRibbon.px(200))
          ])
    ]);

var Styles = {
  boundingBox: boundingBox
};

function SmallHeroTile__CardImage(props) {
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: boundingBox
            });
}

var make = SmallHeroTile__CardImage;

export {
  Styles ,
  make ,
}
/* boundingBox Not a pure module */
